module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Medium-3d0a2e351d3f157d7e6b5bb455649e05.woff";